import React, { PropTypes } from 'react';
import {API} from '../settings.js';
import {ajaxGetHTML} from '../helpers/apiData.js';
import { FormattedMessage } from 'react-intl';

class Terms extends React.Component {

  static propTypes = {
    match: PropTypes.object,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      data: '',
    };
  }

  componentDidMount() {
    ajaxGetHTML(API + this.props.match.params.lang + '/content/1/', this);

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      (<FormattedMessage id="terms-title">
          {(message) => <span>{message}</span>}
        </FormattedMessage>),
      //view
      'terms',
      //back button or not
      false
    );
  }

  // shouldComponentUpdate(nextProps) {
  //     return this.props.match.params !== nextProps.match.params;
  // }

  render() {

    return (
      <div>
        {this.state.data !== '{"status": "error"}' ?
          <div className="static-content" dangerouslySetInnerHTML={{__html: this.state.data}} />
          : null
        }
      </div>
    );
  }
}

export default Terms;




/** WEBPACK FOOTER **
 ** ./src/components/Terms.js
 **/